export const markdownHeaderClasses = {
    h1: "s-heading-2xl",
    h2: "s-heading-xl",
    h3: "s-heading-lg",
    h4: "s-text-base s-font-semibold",
    h5: "s-text-sm s-font-semibold",
    h6: "s-text-sm s-font-regular s-italic",
};
export const markdownParagraphSize = "s-text-base s-leading-7";
//# sourceMappingURL=markdownSizes.js.map